import React, {useRef} from 'react'
import styles from '../componentsStyles/Projects.module.css'

import { motion ,useScroll, useTransform } from 'framer-motion'

const ProjectsImagesMobile2 = () => {

  const imgRef = useRef(null);

  const {scrollYProgress} = useScroll({
    target:imgRef,
    offset: ["start end", "start start"]
  })

  const imgOpacity = useTransform(scrollYProgress,
    [0.3, 0.9],
    [0, 1]  
  )

  const textOpacity = useTransform(scrollYProgress,
    [0.5, 0.9],
    [0, 1]  
  )

  const textSlide = useTransform(scrollYProgress,
    [0, 0.5, 0.8],
    ["-50%", "-25%", "0%"]
  )
  const textSlide1 = useTransform(scrollYProgress,
    [0, 0.6, 0.8],
    ["-50%", "-25%", "0%"]
  )
  const textSlide2 = useTransform(scrollYProgress,
    [0, 0.7, 0.8],
    ["-50%", "-25%", "0%"]
  )
  const textSlide3 = useTransform(scrollYProgress,
    [0, 0.75, 0.8],
    ["-50%", "-25%", "0%"]
  )

  


  return (
    <div className={styles.mobileImg}>
        
      <div className={styles.mobiHeight2}>
        <div className={styles.mobiStikcy} ref={imgRef}>
          <div className={styles.mobiCenter}>
            <motion.div className={styles.mobiImgContainer} style={{opacity: imgOpacity}}>
              <img src="./images/task-handler-3.jpg" alt="not loaded..." />
            </motion.div>
          </div>
          
          <motion.div className={styles.mobiText} style={{opacity: textOpacity}}>

            <motion.h3 style={{x: textSlide}}> 
              Task handler App
            </motion.h3>

            <motion.p style={{x: textSlide1}}>
            Drag and drop the objectives to change the priority.
            </motion.p>

            <motion.p style={{x: textSlide2}}> 
            Every element, tasks, teams and objectives are editable.
            </motion.p>

            <motion.p style={{x: textSlide3}}>
            The user can delete his account at any time.
            </motion.p>
            

          </motion.div>


        </div>
      </div>

    </div>
  )
}

export default ProjectsImagesMobile2